/* eslint-disable prettier/prettier */
import { apiService } from './api.service';
import { UserPreferences, UpdatePreferencesRequest } from '../types/preference';
import { ApiResponse } from '../types';

export const preferenceService = {
	/**
	 * Get user preferences
	 */
	async getUserPreferences(): Promise<ApiResponse<UserPreferences>> {
		return await apiService.get<UserPreferences>('/preference');
	},

	/**
	 * Update/Upsert preferences
	 */
	async updatePreferences(
		data: UpdatePreferencesRequest
	): Promise<ApiResponse<UserPreferences>> {
		// Using PUT as is common for upsert/full update patterns
		return await apiService.put<UserPreferences>(
			'/preference/update',
			data
		);
	},

	/**
	 * Reset preferences to default
	 */
	async resetPreferences(): Promise<ApiResponse<UserPreferences>> {
		return await apiService.post<UserPreferences>('/preference/reset');
	},
};
